<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="8">
        <b-card :header="$t('Shop')" style="position: relative">
          <b-form
            @submit.prevent="onSubmitDetails"
            autocomplete="off"
            ref="cnt"
          >
            <FloatingLabel
              v-model="registry.minimumStake"
              label="Minimum Stake"
              size="sm"
            />
            <FloatingLabel
              v-model="registry.minimumStakePerLine"
              label="Minimum Stake Per Line"
              size="sm"
            />
            <FloatingLabel
              v-model="registry.maximumWinning"
              label="Maximum Winning"
              size="sm"
            />
            <FloatingLabel
              v-model="registry.maximumNumberOfLines"
              label="Maximum Number Of Lines"
              size="sm"
            />
            <FloatingLabel
              v-model="registry.stakeTax"
              label="Stake Tax (%)"
              size="sm"
            />
            <FloatingLabel
              v-model="registry.maximumNumberOfDraws"
              label="Maximum Number Of Draws"
              size="sm"
            />
            <FloatingLabel
              v-model="registry.maxStornoTime"
              label="Max Storno Minutes"
              size="sm"
              description="A duration string which can be a possibly signed sequence of decimal numbers, each with optional fraction and a unit suffix, such as '-1.5h' or '2h45m'. Valid time units are 's', 'm', 'h'."
            />
            <FloatingLabel
              v-model="registry.minCashierVersion"
              label="Min Cashier Version"
              size="sm"
            />
            <b-form-group
              :label="$t('Winning Taxation Ladder')"
              class="grouping p-3 mb-3 mt-0"
            >
              <TaxationLadderEditor
                :items="registry.winningTaxationLadder"
                :addLabel="$t('Add new taxation rule')"
                :deleteTootltip="$t('Delete')"
                :placeholder-min="$t('min amount')"
                :placeholder-max="$t('max amount')"
                :placeholder-rule="$t('rule')"
              />
            </b-form-group>
            <FloatingLabel
              v-model="registry.SMTPSettings"
              label="SMTP Settings"
              size="sm"
              type="textarea"
            />
            <FloatingLabel
              v-model="registry.alertEmailAddresses"
              label="Alert Email Addresses"
              size="sm"
              type="textarea"
            />

            <FloatingLabel
              v-model="registry.emailSendInterval"
              label="Email Send Interval"
              size="sm"
              description="A duration string which can be a possibly signed sequence of decimal numbers, each with optional fraction and a unit suffix, such as '-1.5h' or '2h45m'. Valid time units are 's', 'm', 'h'."
            />

            <FloatingLabel
              v-model="registry.authorizationMaxQueueTime"
              label="Authorization Max Queue Time"
              size="sm"
              description="A duration string which can be a possibly signed sequence of decimal numbers, each with optional fraction and a unit suffix, such as '-1.5h' or '2h45m'. Valid time units are 's', 'm', 'h'."
            />

            <FloatingLabel
              v-model="registry.ticketFooter"
              label="Ticket Footer"
              size="sm"
              type="textarea"
              description="Printed on a ticket"
            />

            <FloatingLabel
              v-model="registry.ticketWinExpirationTime"
              label="Winning Ticket Expiration Time"
              size="sm"
            />

            <FloatingLabel
              v-model="registry.timezone"
              label="Time Zone"
              size="sm"
            />

            <b-form-row>
              <b-col cols="4">
                <FloatingLabel
                  v-model="registry.onlineCashMaxNumberDepositsPerPlayer.value"
                  label="Max Number Of Deposits Per Player"
                  size="sm"
                />
              </b-col>
              <b-col cols="5">
                <FloatingLabel
                  v-model="
                    registry.onlineCashMaxNumberDepositsPerPlayer.interval
                  "
                  label="Per Time Interval"
                  size="sm"
                  description="Valid time units are  's', 'm', 'h', 'd' (eg. 1d2h45m10s)"
                />
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('Do Block Shop')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="
                      registry.onlineCashMaxNumberDepositsPerPlayer.block_shop
                    "
                    :value="true"
                    :unchecked-value="false"
                    >{{ $t("Block Shop") }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('Do Alert')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="
                      registry.onlineCashMaxNumberDepositsPerPlayer.alert
                    "
                    :value="true"
                    :unchecked-value="false"
                    >{{ $t("Alert") }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col cols="4">
                <FloatingLabel
                  v-model="registry.onlineCashMaxTotalSumDepositsPerShop.value"
                  label="Max Total Sum Deposits Per Shop"
                  size="sm"
                />
              </b-col>
              <b-col cols="5">
                <FloatingLabel
                  v-model="
                    registry.onlineCashMaxTotalSumDepositsPerShop.interval
                  "
                  label="Per Time Interval"
                  size="sm"
                  description="Valid time units are  's', 'm', 'h', 'd' (eg. 1d2h45m10s)"
                />
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('Do Block Shop')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="
                      registry.onlineCashMaxTotalSumDepositsPerShop.block_shop
                    "
                    :value="true"
                    :unchecked-value="false"
                    >{{ $t("Block Shop") }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('Do Alert')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="
                      registry.onlineCashMaxTotalSumDepositsPerShop.alert
                    "
                    :value="true"
                    :unchecked-value="false"
                    >{{ $t("Alert") }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col cols="9">
                <FloatingLabel
                  v-model="registry.onlineCashMaxSingleDeposit.value"
                  label="Max Single Deposit"
                  size="sm"
                />
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('Do Block Shop')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="registry.onlineCashMaxSingleDeposit.block_shop"
                    :value="true"
                    :unchecked-value="false"
                    >{{ $t("Block Shop") }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('Do Alert')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="registry.onlineCashMaxSingleDeposit.alert"
                    :value="true"
                    :unchecked-value="false"
                    >{{ $t("Alert") }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col cols="4">
                <FloatingLabel
                  v-model="
                    registry.onlineCashMaxTotalSumDepositsPerPlayer.value
                  "
                  label="Max Total Sum Deposits Per Player"
                  size="sm"
                />
              </b-col>
              <b-col cols="5">
                <FloatingLabel
                  v-model="
                    registry.onlineCashMaxTotalSumDepositsPerPlayer.interval
                  "
                  label="Per Time Interval"
                  size="sm"
                  description="Valid time units are  's', 'm', 'h', 'd' (eg. 1d2h45m10s)"
                />
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('Do Block Shop')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="
                      registry.onlineCashMaxTotalSumDepositsPerPlayer.block_shop
                    "
                    :value="true"
                    :unchecked-value="false"
                    >{{ $t("Block Shop") }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('Do Alert')"
                  class="grouping py-2 px-3 mb-3 mt-0"
                >
                  <b-form-checkbox
                    v-model="
                      registry.onlineCashMaxTotalSumDepositsPerPlayer.alert
                    "
                    :value="true"
                    :unchecked-value="false"
                    >{{ $t("Alert") }}</b-form-checkbox
                  >
                </b-form-group>
              </b-col>
            </b-form-row>

            <div style="text-align: right">
              <b-button type="submit" variant="success">{{
                $t("Save")
              }}</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FloatingLabel from "@/components/FloatingLabel";
import TaxationLadderEditor from "@/components/TaxationLadderEditor";

export default {
  name: "registry",
  components: {
    FloatingLabel,
    TaxationLadderEditor,
  },
  data: function () {
    return {
      registry: {
        minimumStake: "", // type: int64
        minimumStakePerLine: "", // type: int64
        maximumWinning: "", // type: int64
        maximumNumberOfLines: "", // type: int64
        stakeTax: "", // type: double
        maximumNumberOfDraws: "", // type: int
        maxStornoTime: "", // type: int
        minCashierVersion: "", // type: string
        winningTaxationLadder: [], // type: json array
        SMTPSettings: "", // type: json object
        alertEmailAddresses: "", // type: json array
        emailSendInterval: "",
        authorizationMaxQueueTime: "",
        ticketFooter: "",
        ticketWinExpirationTime: "",
        timezone: "",
        onlineCashMaxNumberDepositsPerPlayer: {
          value: "",
          interval: "",
          block_shop: false,
          alert: false,
        }, // "x;y;bool;bool"
        onlineCashMaxTotalSumDepositsPerShop: {
          value: "",
          interval: "",
          block_shop: false,
          alert: false,
        }, // "x;bool;bool"
        onlineCashMaxSingleDeposit: {
          value: "",
          block_shop: false,
          alert: false,
        }, // "x;bool;bool"
        onlineCashMaxTotalSumDepositsPerPlayer: {
          value: "",
          interval: "",
          block_shop: false,
          alert: false,
        }, // "x;y;bool;bool"
        onlineCashLimits: "",
      },
      copy: null,
    };
  },
  created() {
    const self = this;

    const paginationData = {
      rowsPerPage: 0,
      page: 1,
      sortBy: ["key"],
      sortDirection: ["ASC"],
    };

    const loader = this.$loading.open({
      container: this.$refs.cnt,
    });

    this.$store
      .dispatch("registry/fetch", paginationData)
      .then((r) => {
        const tmp = [];
        r.data.rows.forEach((item) => {
          if (typeof self.registry[item.key] === "undefined") return;
          tmp.push(item);
          if (item.key == "winningTaxationLadder") {
            let arr = [];
            try {
              arr = JSON.parse(item.value);
            } catch (err) {
              arr = [];
            }
            const tmp = [];
            arr.forEach((item) => {
              tmp.push([item.minValue, item.maxValue, item.formula]);
            });

            self.registry[item.key] = tmp;
          } else if (item.key === "onlineCashLimits") {
            let value = {};
            try {
              value = JSON.parse(item.value);
            } catch (err) {
              /* noop*/
            }

            if (value.onlineCashMaxNumberDepositsPerPlayer) {
              const parts = value.onlineCashMaxNumberDepositsPerPlayer.split(
                ";",
                4
              );
              if (parts.length === 4) {
                self.registry.onlineCashMaxNumberDepositsPerPlayer = {
                  value: parts[0] ? parts[0] : "",
                  interval: parts[1] ? parts[1] : "",
                  block_shop: parts[2] && parts[2] === "true" ? true : false,
                  alert: parts[3] && parts[3] === "true" ? true : false,
                };
              }
            }
            if (value.onlineCashMaxTotalSumDepositsPerShop) {
              const parts = value.onlineCashMaxTotalSumDepositsPerShop.split(
                ";",
                4
              );
              if (parts.length === 4) {
                self.registry.onlineCashMaxTotalSumDepositsPerShop = {
                  value: parts[0] ? parts[0] : "",
                  interval: parts[1] ? parts[1] : "",
                  block_shop: parts[2] && parts[2] === "true" ? true : false,
                  alert: parts[3] && parts[3] === "true" ? true : false,
                };
              }
            }
            if (value.onlineCashMaxTotalSumDepositsPerPlayer) {
              const parts = value.onlineCashMaxTotalSumDepositsPerPlayer.split(
                ";",
                4
              );
              if (parts.length === 4) {
                self.registry.onlineCashMaxTotalSumDepositsPerPlayer = {
                  value: parts[0] ? parts[0] : "",
                  interval: parts[1] ? parts[1] : "",
                  block_shop: parts[2] && parts[2] === "true" ? true : false,
                  alert: parts[3] && parts[3] === "true" ? true : false,
                };
              }
            }
            if (value.onlineCashMaxSingleDeposit) {
              const parts = value.onlineCashMaxSingleDeposit.split(";", 3);
              if (parts.length === 3) {
                self.registry.onlineCashMaxSingleDeposit = {
                  value: parts[0] ? parts[0] : "",
                  block_shop: parts[1] && parts[1] === "true" ? true : false,
                  alert: parts[2] && parts[2] === "true" ? true : false,
                };
              }
            }
          } else {
            self.registry[item.key] = item.value;
          }
        });
        self.copy = tmp;
      })
      .finally(() => {
        loader.close();
      });
  },
  methods: {
    onSubmitDetails() {
      const self = this;

      const loader = this.$loading.open({
        container: this.$refs.cnt,
      });

      const r = JSON.parse(JSON.stringify(this.registry));

      const promisses = [];

      const tmp = [];
      r.winningTaxationLadder.forEach((item) => {
        tmp.push({ minValue: item[0], maxValue: item[1], formula: item[2] });
      });
      r.winningTaxationLadder = JSON.stringify(tmp);

      const onlineCashLimits = {};

      let key = "onlineCashMaxNumberDepositsPerPlayer";
      onlineCashLimits[key] = this.fourValuesToString(r[key]);
      key = "onlineCashMaxTotalSumDepositsPerShop";
      onlineCashLimits[key] = this.fourValuesToString(r[key]);
      key = "onlineCashMaxSingleDeposit";
      onlineCashLimits[key] = this.threeValuesToString(r[key]);
      key = "onlineCashMaxTotalSumDepositsPerPlayer";
      onlineCashLimits[key] = this.fourValuesToString(r[key]);

      r.onlineCashLimits = JSON.stringify(onlineCashLimits);

      this.copy.forEach((item, index) => {
        if (r[item.key] != item.value) {
          promisses.push(
            self.$store
              .dispatch("registry/update", {
                eid: item.eid,
                key: item.key,
                value: r[item.key],
              })
              .catch((e) => e)
          );
          self.copy[index].value = r[item.key];
        }
      });

      Promise.all(promisses).finally(() => {
        loader.close();
      });
    },
    fourValuesToString(data) {
      return `${typeof data.value !== "undefined" ? data.value : ""};${
        typeof data.interval !== "undefined" ? data.interval : ""
      };${data.block_shop ? "true" : "false"};${data.alert ? "true" : "false"}`;
    },
    threeValuesToString(data) {
      return `${typeof data.value !== "undefined" ? data.value : ""};${
        data.block_shop ? "true" : "false"
      };${data.alert ? "true" : "false"}`;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
